import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import {ref, watch} from "vue";

type USContainsPercentOfFormProps = {
  value: number | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vUSContainsPercentOfForm',
  props: {
    value: null
  },
  emits: ["update:value", "all-input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: number | null;
};



const translations = useTranslations();

const useContainsLessThanText = ref(true);
const model = ref(props.value);
const acceptableThresholds = [0.5, 1.0, 1.5, 2.0];

function handleCheck(value: boolean) {
  useContainsLessThanText.value = value;

  if (value) {
    emit("update:value", 2.0);
  }

  else {
    emit("update:value", 0);
  }

  emit("all-input");
}

watch(model, (newValue) => emit("update:value", newValue));

return { __sfc: true,props, emit, translations, useContainsLessThanText, model, acceptableThresholds, handleCheck }
}

})